import React from "react";
import {
	Card,
	CardBody,
	CardTitle,
	Row,
	Col,

} from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';

import {
	DevicesBatchUpload
} from '../../components/devices-batch-upload/';

class DevicesBatchUploadView extends React.Component {

	constructor(props) {
    super(props);

  }

	componentDidMount() {

	}

	render() {
		return (
			<div>
				<Row>
					<Col md="12">
            <DevicesBatchUpload />
					</Col>
				</Row>
			</div>
		);
	}
}

export default DevicesBatchUploadView;
